import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateAgoPipe } from './date-ago.pipe';
import { SearchPipe } from './search.pipe';
import { ListDetailPipe } from './list-detail.pipe';
import { ImagePipe } from './image.pipe';
import { DolarPipe } from './dolar.pipe';


@NgModule({
  declarations: [
    DateAgoPipe,
    SearchPipe,
    ListDetailPipe,
    ImagePipe,
    DolarPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DateAgoPipe,
    SearchPipe,
    ListDetailPipe,
    ImagePipe,
    DolarPipe
  ]
})
export class PipeModule { }
